import React, { Component } from "react";

import { ITitleSlideComponentProps } from "../types/props";
import { EchallengeImages, EDirection } from "../enums";
import { INDEX_CONFIG, SEGMENT_CONFIG, BUFFER_CONFIG, CATEGORY_CONFIG } from "../config";
import closeImage from "../../assets/close.svg";
import ReactTooltip from "react-tooltip";
import "./titleSlide.component.scss";
class TitleSlideComponent extends Component<ITitleSlideComponentProps> {
  render() {
    return (
      <div className="title-slide">
        <h3 data-tip={this.getTitle().length > 30 ? this.getTitle() : null}>
          {this.getTitle()}
        </h3>
        <button className="title-slide--remove" onClick={this.remove}>
          <img src={`/dist/${closeImage}`} />
          <span className="sr-only">Remove</span>
        </button>
      </div>
    );
  }

  remove = () => {
    this.props.removeSlide(this.props.section);
  };

  getTitle = () => {
    const index = INDEX_CONFIG[this.props.meta.index];
    const segment = SEGMENT_CONFIG[this.props.meta.segment];
    const buffer = BUFFER_CONFIG[this.props.meta.protection];
    if (index === undefined) {
      return `Not Configured`;
    } else return index + ' ' + segment + ' with ' + buffer;
  };
}

export default TitleSlideComponent;
